import styled from 'styled-components';

type PortfolioSearchContainerProps = {
  isMobileDevice: boolean;
  isSearchBarOpen: boolean;
};

export const PortfolioSearchContainer = styled.div<PortfolioSearchContainerProps>`
  ${(props) => (props.isSearchBarOpen && props.isMobileDevice ? `width: 100%;` : ``)}
`;
